// src/assets/data/mindLines.ts
export const mindLines = [
  "这几个字看着就有点难…",
  "会不会一屏数学公式？",
  "优化=把东西变好？",
  "和测图出图有啥关系？",
  "能少飞几趟无人机吗？",
  "外业省时，我就爱。",
  "内业出图能更快吗？",
  "优化=AI调参炼丹？",
  "能不能不写公式，先给我看个例子？",
  "数据很糟也能优化？",
  "要人工调参吗？怎么调才稳？",
  "我数学一般能听懂吗？",
  "这是光束平差那一套？",
  "'最优'谁说了算？",
  "除了空三还有啥应用？",
  "听完能立刻上手吗？",
  "听起来很难，和我有关系吗？",
  "只有一个最优解吗？",
  "万一有好多条路呢？",
  "世界上真的有最优解吗？",
  "数据错了能优化回来吗？",
  "不求最优，有'够好就行'的解吗？"
];